/**
 * Repaints the customer website by rewriting the CSS custom properties the
 * stylesheet already reads. No rebuild, no component changes - the whole panel
 * is themed through :root variables, so setting them is the whole job.
 */
const VAR_MAP = {
  primary: '--primary',
  primaryDark: '--primary-dark',
  primaryLight: '--primary-light',
  primarySoft: '--primary-soft',
  accent: '--accent',
  accentLight: '--accent-light',
  ink: '--ink',
  ink2: '--ink2',
  muted: '--muted',
  faint: '--faint',
  line: '--line',
  bg: '--bg',
  card: '--card',
};

const STORAGE_KEY = 'kw_web_theme';

export const applyWebTheme = (theme) => {
  if (!theme || !theme.colors) return;
  const root = document.documentElement;
  Object.entries(VAR_MAP).forEach(([token, cssVar]) => {
    if (theme.colors[token]) root.style.setProperty(cssVar, theme.colors[token]);
  });
  root.dataset.theme = theme.dark ? 'dark' : 'light';
  try { localStorage.setItem(STORAGE_KEY, JSON.stringify(theme)); } catch (e) { /* private mode */ }
};

/** Repaints from cache on boot so the panel never flashes the wrong palette. */
export const restoreWebTheme = () => {
  try {
    const saved = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
    if (saved) applyWebTheme(saved);
  } catch (e) { /* nothing cached */ }
};

export default applyWebTheme;
